import React from "react";
import {classNames} from "../../util/util-helpers";


const CardSubTitle = ({ text, addClass }) => {

    return (
        <h5 className={classNames(addClass, 'text-tm-white-700 text-base')}>{text}</h5>
    )
}

export default CardSubTitle



